module.exports = __webpack_public_path__ + "img/AhmadSubagyo-nologo.19818729.png";